import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { convertToBool } from '../../util.jsx';
import ValidationMessage from '@/js/components/common/ValidationMessage';
import '@/scss/components/common/ToggleButton.scss';

class ToggleButton extends React.PureComponent {
	constructor(props) {
		super(props);

		this.onBlur = this.onBlur.bind(this);
		this.onFocus = this.onFocus.bind(this);

		/* which label is focused, the 'yes' label or the 'no' label */
		this.state = {
			yesFocused: false,
			noFocused: false
		};
	}
	/* yesField == true just means we are dealing with the 'yes' input as opposed to the 'no' input */
	/* and set the correct input's state accordingly */
	onBlur(yesField) {
		if (!this.props.disabled) {
			yesField ? this.setState({ yesFocused: false }) : this.setState({ noFocused: false });
		}
	}
	onFocus(yesField) {
		if (!this.props.disabled) {
			yesField ? this.setState({ yesFocused: true }) : this.setState({ noFocused: true });
		}
	}

	render() {
		/*there's really 3 states we need to handle: true, false, and undefined
		/* value should initially be undefined, we don't want to convert that to a boolean */
		let boolVal = undefined;
		if(this.props.value !== undefined) boolVal = convertToBool(this.props.value);

		return (
			<fieldset className="ToggleButton">
				<div className="d-flex align-items-center justify-content-between">
					<legend className="col-form-label">{this.props.label}</legend>
					<div className={cx("btn-group", "btn-group-toggle", (this.props.errorMessage ? "tropic-invalid" : ""))}>
						{/*the actual radio button input is hidden (so that it receives keyboard tabbing, and maintains display: inline while still maintaining the look of the label vs html circular radios */}
						{/* first label gets a bootstrap focus class if yesFocused or noFocused */}


						<label className={cx('btn', 'btn-sm', 'btn-primary', 'toggleButtonTrue',
							{focus: this.state.yesFocused, active: boolVal, disabled: this.props.disabled}
						)}
						>
							<input onChange={e => this.props.onChange(true)}
								type="radio"
								name={this.props.name}
								autoComplete="off"
								value={true}
								onFocus={e => this.onFocus(true)}
								onBlur={e => this.onBlur(true)}
								disabled={this.props.disabled ? true : undefined}
								checked={this.props.value} // allow toggle to reset after on page submission
								>
							</input>
							{this.props.trueDisplay}
						</label>
						<label className={cx('btn', 'btn-sm', 'btn-primary', 'toggleButtonFalse',
							{focus : this.state.noFocused, active: (boolVal === undefined ? false : !boolVal), disabled: this.props.disabled}
						)}
						>
							<input onChange={e => this.props.onChange(false)}
								type="radio"
								name={this.props.name}
								autoComplete="off"
								value={false}
								onFocus={e => this.onFocus(false)}
								onBlur={e => this.onBlur(false)}
								disabled={this.props.disabled ? true : undefined}
								>
							</input>
							{this.props.falseDisplay}
						</label>
					</div>
				</div>
				{this.props.errorMessage &&
					<ValidationMessage message={this.props.errorMessage}/>
				}
			</fieldset>
		);
	}
}


ToggleButton.propTypes = {
	value: PropTypes.bool,
	name: PropTypes.string,
	trueDisplay: PropTypes.string,
	falseDisplay: PropTypes.string,
	label: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	errorMessage: PropTypes.string.isRequired,
	disabled: PropTypes.bool
};

ToggleButton.defaultProps = {
	trueDisplay: 'Yes',
	falseDisplay: 'No'
};

export default ToggleButton;
